/* corbier-luxe.js — small motion helpers for the V1 design layer (no dependencies).
   1. html.wc-scrolled once the page leaves the top (compact header)
   2. soft fade-in for images that are still loading when they enter the page */
(function () {
  'use strict';
  var root = document.documentElement;

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      root.classList.toggle('wc-scrolled', window.scrollY > 12);
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  function fadeIn(scope) {
    var imgs = (scope || document).querySelectorAll('.card__media img, .product__media img, .banner__media img, .image-with-text__media img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.dataset.wcFade || img.complete) continue;
      img.dataset.wcFade = '1';
      img.classList.add('wc-img');
      img.addEventListener('load', function () { this.classList.add('wc-in'); }, { once: true });
      img.addEventListener('error', function () { this.classList.add('wc-in'); }, { once: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { fadeIn(); });
  else fadeIn();
  document.addEventListener('shopify:section:load', function (e) { fadeIn(e.target); });

  /* 3. product gallery: the next two photos are fetched as soon as the page has settled, the rest the moment the visitor touches the gallery
        (or after 8 s), one by one, so swiping and the thumbnails never wait on a lazy image. Skipped on data-saver / 2G. */
  var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 400); };
  var warmTimer = 0, warmBound = null;
  function lazyPhotos() { return document.querySelectorAll('.product__media-list img[loading="lazy"]'); }
  function warmSome(limit) {
    var imgs = lazyPhotos(), i = 0, n = Math.min(limit, imgs.length);
    (function next() {
      if (i >= n) return;
      var img = imgs[i++];
      if (img.isConnected) { img.loading = 'eager'; img.decoding = 'async'; }
      setTimeout(function () { idle(next); }, 200);
    })();
  }
  function warmGallery() {
    var c = navigator.connection;
    if (c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || ''))) return;
    var wrap = document.querySelector('.product__media-wrapper');
    if (!wrap || !lazyPhotos().length) return;
    warmSome(2);
    if (warmBound) warmBound.forEach(function (x) { x[0].removeEventListener(x[1], x[2]); });
    clearTimeout(warmTimer);
    var rest = function () { clearTimeout(warmTimer); if (warmBound) warmBound.forEach(function (x) { x[0].removeEventListener(x[1], x[2]); }); warmBound = null; warmSome(99); };
    warmBound = ['touchstart', 'pointerdown', 'wheel', 'keydown'].map(function (ev) { wrap.addEventListener(ev, rest, { passive: true, once: true }); return [wrap, ev, rest]; });
    warmTimer = setTimeout(rest, 8000);
  }
  function scheduleWarm() { idle(function () { setTimeout(warmGallery, 800); }); }
  if (document.readyState === 'complete') scheduleWarm(); else window.addEventListener('load', scheduleWarm, { once: true });
  document.addEventListener('corbier:product:change', scheduleWarm);
  /* 4. phone product photo: thin dashes, one per photo, the current one is longer and follows the swipe (replaces the 1/10 counter) */
  function initDots() {
    var viewer = document.querySelector('slider-component[id^="GalleryViewer"]');
    if (!viewer || viewer.querySelector('.wc-gdots')) return;
    var list = viewer.querySelector('.product__media-list');
    var slides = list ? list.querySelectorAll('.product__media-item') : [];
    if (slides.length < 2) return;
    var wrap = document.createElement('div');
    wrap.className = 'wc-gdots';
    wrap.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < slides.length; i++) wrap.appendChild(document.createElement('span'));
    viewer.appendChild(wrap);
    var dots = wrap.children, cur = -1, raf = 0;
    function sync() {
      raf = 0;
      var step = slides[1].getBoundingClientRect().left - slides[0].getBoundingClientRect().left;
      var idx = step > 0 ? Math.round(list.scrollLeft / step) : 0;
      if (list.scrollLeft >= list.scrollWidth - list.clientWidth - 2) idx = slides.length - 1;
      idx = Math.max(0, Math.min(slides.length - 1, idx));
      if (idx === cur) return;
      if (cur > -1) dots[cur].classList.remove('is-on');
      dots[idx].classList.add('is-on');
      cur = idx;
    }
    list.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(sync); }, { passive: true });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initDots); else initDots();
  document.addEventListener('corbier:product:change', initDots);
  document.addEventListener('shopify:section:load', initDots);

  /* 5. sideways rows without their own markers (feature cards on phones): the gallery dashes under the row, the current card's dash is longer */
  function addDashes(list) {
    if (!list || list.dataset.wcDashes) return;
    list.dataset.wcDashes = '1';
    var cards = list.children;
    if (cards.length < 2) return;
    var row = document.createElement('div');
    row.className = 'wc-dashes';
    row.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < cards.length; i++) row.appendChild(document.createElement('span'));
    list.parentNode.insertBefore(row, list.nextSibling);
    var cur = -1, raf = 0;
    function update() {
      raf = 0;
      var max = list.scrollWidth - list.clientWidth;
      row.hidden = max < 4;
      var step = cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left;
      var idx = step > 0 ? Math.round(list.scrollLeft / step) : 0;
      if (list.scrollLeft >= max - 2) idx = cards.length - 1;
      idx = Math.max(0, Math.min(cards.length - 1, idx));
      if (idx === cur) return;
      if (cur > -1) row.children[cur].classList.remove('is-on');
      row.children[idx].classList.add('is-on');
      cur = idx;
    }
    list.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', function () { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
    update();
  }
  function initDashes() { document.querySelectorAll('.wc-feat__list').forEach(addDashes); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initDashes); else initDashes();
  document.addEventListener('shopify:section:load', initDashes);

  /* 6. end of the page: flag it so the floating add-to-bag bar does not cover the footer's last lines (address, payment icons) */
  function watchPageEnd() {
    var last = document.querySelector('.footer__content-bottom') || document.querySelector('.shopify-section-group-footer-group');
    if (!last || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) { root.classList.toggle('wc-page-end', entries[0].isIntersecting); }).observe(last);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchPageEnd); else watchPageEnd();
})();
